module.exports = __webpack_public_path__ + "img/art-kids-m.0d54398c.png";